import { Component, Input, Output, EventEmitter, ElementRef, HostListener, OnChanges, SimpleChanges } from "@angular/core";
import { Chip } from "../models/chip";

@Component({
  selector: "auto-suggest",
  templateUrl: "./auto.suggest.template.html",
  styleUrls: ["./auto.suggest.style.scss"]
})
export class AutoSuggestComponent implements OnChanges {
  @Input() dataSource: Array<Chip>;
  @Input() isAnalytics: boolean;
  @Output() onClick = new EventEmitter();

  dataList: Array<Chip>;
  selectedIndex = -1;
  className = "selected";
  constructor(private elementRef: ElementRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataSource && changes.dataSource.currentValue) {
      this.dataList = Array.from(this.dataSource);
      this.changeSelectionIndex(-1);
    }
  }

  getItemsRef(index) {
    return this.elementRef.nativeElement.children[index];
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (!this.dataList.length) {
      return;
    }

    switch (event.keyCode) {
      case KEY_CODE.ARROW_UP:
        this.onArrowUp();
        event.preventDefault();
        break;
      case KEY_CODE.ARROW_DOWN:
        this.onArrowDown();
        event.preventDefault();
        break;
      case KEY_CODE.ENTER:
        this.onEnter();
        event.preventDefault();
        break;
      case KEY_CODE.TAB:
        if (this.isAnalytics && this.dataList.length === 1) {
          this.dataList[0]['tab'] = true;
          this.click(this.dataList[0]);
        }
        event.preventDefault();
        break;
    }
  }

  @HostListener("window:mousemove")
  onMouseMove() {
    this.changeSelectionIndex(-1);
  }

  onArrowUp() {
    this.changeSelection(Math.max(this.selectedIndex - 1, 0));
  }

  onArrowDown() {
    this.changeSelection(Math.min(this.selectedIndex + 1, Math.max(this.dataList.length - 1, 0)));
  }

  onEnter() {
    this.click(this.dataList[this.selectedIndex]);
  }

  private changeSelection(nextIndex: number) {
    this.changeSelectionIndex(nextIndex);
    this.getItemsRef(nextIndex).classList.add(this.className);
    this.getItemsRef(nextIndex).scrollIntoViewIfNeeded();
  }

  private changeSelectionIndex(value) {
    if (this.getItemsRef(this.selectedIndex)) {
      this.getItemsRef(this.selectedIndex).classList.remove(this.className);
    }
    this.selectedIndex = value;
  }

  click(item) {
    this.changeSelectionIndex(-1);
    this.onClick.emit(item);
  }
}

export enum KEY_CODE {
  ARROW_DOWN = 40,
  ARROW_UP = 38,
  ENTER = 13,
  TAB = 9
}